import * as React from "react";
import { E2EIdentifier } from "../../../../e2e/E2EIdentifier";
import { IDialog } from "../Dialogs";
import { MessageWrapper } from "./MessageWrapper";

export function DialogContent({
  message,
  scrollable,
  centerMessage
}: Pick<IDialog, "message" | "scrollable" | "centerMessage"> & {
  children?: React.ReactNode;
}) {
  if (typeof message === "string") {
    return (
      <MessageWrapper
        data-e2e-id={E2EIdentifier.DIALOG_MESSAGE}
        centerMessage={centerMessage}
        scrollable={scrollable}
      >
        {message}
      </MessageWrapper>
    );
  } else if (Array.isArray(message)) {
    return (
      <MessageWrapper
        data-e2e-id={E2EIdentifier.DIALOG_MESSAGE}
        centerMessage={centerMessage}
        scrollable={scrollable}
      >
        {message.map(({ text, url }, index) => {
          if (!url) {
            return text;
          }

          return (
            <a key={index} href={url} target="_blank">
              {text}
            </a>
          );
        })}
      </MessageWrapper>
    );
  }

  return null;
}
